import React, { useState, useEffect } from "react";

export default function ColorSwatch({ variants = [], maxVisible }) {
    const [visibleCount, setVisibleCount] = useState(maxVisible || 5);

    useEffect(() => {
        const updateVisible = () => {
            if (window.innerWidth < 640) {
                // Mobile (Tailwind breakpoint: sm)
                setVisibleCount(2);
            } else {
                // Desktop
                setVisibleCount(4);
            }
        };

        updateVisible();
        window.addEventListener("resize", updateVisible);
        return () => window.removeEventListener("resize", updateVisible);
    }, [maxVisible]);

    const normalized = variants.map((v) => ({
        id: v._id,
        name: v.colorName || v.colour || "Unknown",
        hex: v.colorHex || null,
    }));

    const dedupedMap = new Map();
    for (const c of normalized) {
        const key = (c.hex || c.name || "").toLowerCase();
        if (!dedupedMap.has(key)) dedupedMap.set(key, c);
    }
    const colors = Array.from(dedupedMap.values());

    const visible = colors.slice(0, visibleCount);
    const remaining = colors.length - visible.length;

    return (
        <div className="flex items-center space-x-3 mt-2">
            <div className="flex -space-x-2 gap-3 justify-end">
                {visible.map((c) => (
                    <div
                        key={c.id}
                        className={`w-4 h-4 rounded-full flex items-center justify-center text-xs font-medium text-gray-700 border ${!c.hex || c.hex.toLowerCase() === "#ffffff" || c.hex.toLowerCase() === "#fff"
                            ? "border-gray-300"
                            : "border-transparent"
                            }`}
                        title={c.name + (c.hex ? ` (${c.hex})` : "")}
                        style={c.hex ? { backgroundColor: c.hex } : { backgroundColor: "#f3f4f6" }}
                        aria-label={c.name}
                    >
                        {!c.hex && <span className="text-[10px]">{c.name[0]?.toUpperCase() || "?"}</span>}
                    </div>
                ))}
            </div>

            {remaining > 0 && (
                <div className="ml-1 text-sm text-gray-600">+{remaining} more</div>
            )}
        </div>
    );
}





// import React from "react";

// export default function ColorSwatch({ variants = [], maxVisible = 4 }) {
//     const normalized = variants.map((v) => ({
//         id: v._id,
//         name: v.colorName || v.colour || "Unknown",
//         hex: v.colorHex || null,
//     }));

//     const dedupedMap = new Map();
//     for (const c of normalized) {
//         const key = (c.hex || c.name || "").toLowerCase();
//         if (!dedupedMap.has(key)) dedupedMap.set(key, c);
//     }
//     const colors = Array.from(dedupedMap.values());

//     const visible = colors.slice(0, maxVisible);
//     const remaining = colors.length - visible.length;

//     return (
//         <div className="flex items-center space-x-3">
//             <div className="flex -space-x-2 gap-3 justify-end">{
//                 visible.map((c) => (
//                     <div
//                         key={c.id}
//                         className={`w-5 h-5 rounded-full flex items-center justify-center text-xs font-medium text-gray-700 border ${(!c.hex || c.hex.toLowerCase() === '#ffffff' || c.hex.toLowerCase() === '#fff') ? 'border-gray-300' : 'border-transparent'}`}
//                         title={c.name + (c.hex ? ` (${c.hex})` : '')}
//                         style={c.hex ? { backgroundColor: c.hex } : { backgroundColor: '#f3f4f6' }}
//                         aria-label={c.name}
//                     >
//                         {!c.hex && <span className="text-[10px]">{c.name[0]?.toUpperCase() || '?'}</span>}
//                     </div>
//                 ))
//             }</div>

//             {remaining > 0 && (
//                 <div className="ml-1 text-sm text-gray-600">+{remaining} more</div>
//             )}


//         </div>
//     );
// }